import { hashId } from '~kui/utils/hash';

// Static fallback covers for learning collections without an uploaded image.
// Served from public/, referenced by root-relative path.
const COVER_FALLBACK_IMAGES = [
  '/images/schools/lesson-fallback-1.webp',
  '/images/schools/lesson-fallback-2.webp',
  '/images/schools/lesson-fallback-3.webp',
];

/** Deterministically pick one of three fallback covers from the collection id (stable per collection). */
export const coverFallbackImage = (id: string): string =>
  COVER_FALLBACK_IMAGES[hashId(id) % COVER_FALLBACK_IMAGES.length]!;
